import React from 'react';

import { BarTask } from '@interfaces/ganttTasks/barTask';

import colors from '@constants/colors';

import styles from './Milestone.module.scss';

const Milestone = ({ task }: { task: BarTask }) => {
	const milestoneWidth = task.x2 - task.x1;

	return (
		<g
			className={styles.milestoneWrapper}
			tabIndex={0}
		>
			<rect
				className={styles.milestoneBackground}
				fill={colors.cyan10}
				height={task.height}
				rx={task.barCornerRadius}
				ry={task.barCornerRadius}
				width={milestoneWidth}
				x={task.x1}
				y={task.y}
			/>
		</g>
	);
};

export default Milestone;
